export const API_USER = `${process.env.REACT_APP_MS_API_URL}/user`;
export const API_GRADE = `${process.env.REACT_APP_MS_API_URL}/grade`;
export const API_ABSENCE = `${process.env.REACT_APP_MS_API_URL}/absence`;
export const API_HOMEWORK = `${process.env.REACT_APP_MS_API_URL}/homework`;
export const API_ASSIST = `${process.env.REACT_APP_MS_API_URL}/assist`;